export default __webpack_public_path__ + "static/media/delivery.18fdba77.webp";